import { getCookie } from "../../../cookieHelper";
import { parseError } from "../utils/ErrorHandling";

const BASE = "/api/lending/edge/two_factor_session";

export interface TwoFactorSessionStatus {
  required: boolean;
  has_device: boolean;
  device_remembered: boolean;
}

export interface TwoFactorSessionSetup {
  setup_uri: string;
  account: string;
  key: string;
  setup_token: string;
}

export interface TwoFactorSessionError {
  status: number;
  code: string;
  message: string;
}

async function edgeFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(`${BASE}${path}`, {
    credentials: "include",
    mode: "same-origin",
    ...init,
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": getCookie("csrftoken") ?? "",
      ...init.headers,
    },
  });

  if (!response.ok) {
    const text = await response.text();
    const parsed = parseError(text);
    throw {
      status: response.status,
      code: parsed?.code ?? `HTTP_${response.status}`,
      message: parsed?.detail ?? response.statusText,
    } satisfies TwoFactorSessionError;
  }

  return (await response.json()).data as T;
}

export const getTwoFactorSessionStatus = () =>
  edgeFetch<TwoFactorSessionStatus>("/status/");

export const verifyTwoFactorSession = async (body: {
  otp?: string;
  remember_device?: boolean;
}) =>
  (
    await edgeFetch<{ assertion: string }>("/verify/", {
      method: "POST",
      body: JSON.stringify({ data: body }),
    })
  ).assertion;

export const getTwoFactorSessionSetup = () =>
  edgeFetch<TwoFactorSessionSetup>("/setup/");

export const completeTwoFactorSessionSetup = async (body: {
  setup_token: string;
  otp: string;
}) =>
  (
    await edgeFetch<{ assertion: string }>("/setup/", {
      method: "POST",
      body: JSON.stringify({ data: body }),
    })
  ).assertion;
